import { createAction } from '@reduxjs/toolkit';
import { Asset, AssetLink } from '../../api';
import { AssetLinkShape } from './model';

export const deleteConfirmed = createAction<{ assetId: Asset['id']; linkId: AssetLink['id'] }>(
  'al/assetLink/deleteConfirmed',
);

export const deleted = createAction<{ assetId: Asset['id']; linkId: AssetLink['id'] }>(
  'al/assetLink/deleted',
);

export const saved = createAction<{ link: AssetLink }>('al/assetLink/saved');

export const editSubmitted = createAction<{
  assetId: Asset['id'];
  linkId: AssetLink['id'] | undefined;
  url: AssetLink['url'];
}>('al/assetLink/editSubmitted');

export const setInProgress = createAction<{ inProgress: AssetLinkShape['inProgress'] }>(
  'al/assetLink/setInProgress',
);
